<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Imagens Banner - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'bannerphotos'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>
    <form-banner-photo :btnLabel="btnLabel"></form-banner-photo>
</span>
</template>

<script>
import FormBannerPhotoComponent from "./partial/FormBannerPhotoComponent";

export default {
    name: "AddBannerPhotoComponent",
    created() {

    },
    data() {
        return {
            btnLabel: 'Incluir',
            //id_setor: this.id,
        }
    },
    methods: {

    },
    components: {
        formBannerPhoto: FormBannerPhotoComponent,
    }
};
</script>

<style scoped>

</style>
